export const getSx = () => {
  return {
    contentBox: {
      width: "100%",
    },
    rightBoxContainer: {
      marginTop: "1.5rem",
      display: "flex",
      flexDirection: "column",
      gap: "6px",
      position: "relative",
    },
    text: {
      fontSize: "18px",
      fontWeight: 600,
      color: "#15151599",
      marginBottom: "8px",
    },
    textData: {
      color: "black",
    },
    name: {
      textTransform: "capitalize",
    },
  };
};
